goog.provide('el8.appanalytics.dialog.billingReportCSV');

goog.require('el8.template.appanalytics.dialog.downloadCSV');
goog.require('el8.uiwidget.NewDialog');

el8.appanalytics.dialog.billingReportCSV = (function() {

    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton(
        'close', 'Dismiss', function() {
            that.hide();
            that._contentElt.html(el8.template.appanalytics.dialog.downloadCSV.content(
                {'name': 'billing report'}
            ));
        }, false
    );

    var that = new el8.uiwidget.NewDialog({
        title: 'Download Billing Report Results as CSV',
        modal: true,
        contentFn: function () {
            return el8.template.appanalytics.dialog.downloadCSV.content({'name': 'billing report'});
        },
        showXButton: false,
        height: 200,
        width: 520,
        buttonSet: buttonSet
    });

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        that._bindTriggers();
    };

    that._bindTriggers = function() {
        that.getContentElt().on('click', '.download-trigger',  function(e) {
            var url = $(this).attr('data-url');
            if (url) { window.open(url); }
        });
    };

    var super_show = that.show;
    that.show = function(physicianId, key, fromDate, toDate) {
        super_show.call(that);

        var successCb = function (data) {
            var url = el8.service.urls.get('billingReportCSVDownload', [data['csv_id']]);
            that._contentElt.html(el8.template.appanalytics.dialog.downloadCSV.done(
                {
                    'url': url,
                    'name': 'billing report'
                }
            ));
        };

        $.el8_longPoll({
            url: el8.service.urls.get('billingReportCSV'),
            data: JSON.stringify({"physician_id": physicianId || null,
                                  "key": key || null,
                                  "from": fromDate || null,
                                  "to": toDate || null}),
            success: successCb,
            error: function(data) {
                el8.appservice.notifier.clear();
                el8.uiwidget.alert(el8.util.consts.DEFAULT_ERROR_MSG);
            }
        });
    };

    return that;

})();
